<template lang="pug">
server-data(
  ref="serverData"
  v-model="items"
  v-bind="serverDataAttrs"
  @data:init="dataInit"
  v-on="$listeners"
  v-slot="{ pagination, loading, serverData: items, init, query, queryList, hasMore, loadMoreItems }"
)
  slot(name="filters" v-bind="{ items, init, query, loading, queryList }")
    dv-tabs(
      v-if="hasFilter"
      :value="filterTab"
      @change="filterTab = $event; init();"
      v-bind="{ bordered: true, height: 32, class: 'mb-8', ...(filterProps && filterProps.attrs) }"
      v-on="filterProps && filterProps.listeners"
    )
      dv-tab(
        v-for="({ text, attrs, listeners }, idx) in filterTabs"
        :tab-value="idx"
        :key="idx"
        v-bind="{ disabled: loading, ...attrs }"
        v-on="listeners"
      )
        h3 {{ text }}
  slot(name="search" v-bind="{ items, init, query, loading, queryList }")
    component(
      v-if="hasSearch"
      :is="searchComponent"
      :class="[{ 'mb-2': searchProps.mini }, { 'mb-4': !searchProps.mini }]"
      :method="($event) => query('table', { ...$event })"
      :loading="loading"
      :query="{ ...((queryList && queryList['table']) || {}), ...((searchProps.attrs && searchProps.attrs.query) || {}) }"
      v-bind="searchProps.attrs"
      v-on="searchProps.listeners"
    )
      template(
        v-for="(_, name) in $scopedSlots"
        v-slot:[name]="data"
      )
        slot(:name="name" v-bind="{ ...data, items, init, loading, base: { queryList, query } }")
      template(
        v-for="(_, name) in $slots"
        :slot="name"
      )
        slot(:name="name")

  slot(name="pagination" v-bind="{ items, loading, pagination }")
    .d-flex.gap-24.ga-6.align-center.mb-4(v-if="hasSearch && showPagination")
      template(v-if="!loading && pagination")
        p.ui-h3.ui-neutral--text
          span.mr-1 {{ pagination.totalCount ? 'Всего:' : 'Не найдено' }}
          span.opacity-70(v-if="pagination.totalCount") {{ pagination.totalCount }}

  div(:class="{ 'pointer-events-none': loading }")
    slot(name="default" v-bind="{ pagination, items, loading, init, refresh, hasMore, loadMoreItems }")

  slot(name="no-data" v-bind="{ loading, items }")
    no-data(
      v-if="!loading && !(items && items.length)"
      text="Ничего не нашлось"
    )
  slot(name="loader" v-bind="{ loading, hasMore, loadMoreItems }")
    text-loader.pointer-events-none.user-select-none(
      v-if="loading"
      :is-init="false"
    )
    div(
      v-else-if="hasMore"
      v-intersect="([{ isIntersecting }]) => isIntersecting && loadMoreItems()"
    )

</template>

<script>
import DSearchFields from '../DApiDataTable/DSearchFields.vue';
import DSearchFieldsMini from '../DApiDataTable/DSearchFieldsMini.vue';
import DvTab from '../inputs/tabs/DvTab.vue';
import DvTabs from '../inputs/tabs/DvTabs.vue';
import NoData from '../NoData.vue';

export default {
  components: {
    DSearchFields,
    DSearchFieldsMini,
    DvTab,
    DvTabs,
    NoData,
  },
  props: {
    method: { type: Function, required: true },
    value: { type: Array, default: () => ([]) },
    searchProps: { type: Object, default: () => ({ mini: false, attrs: {}, listeners: {} }) },
    filterProps: { type: Object, default: () => ({ tabs: [], attrs: {}, listeners: {} }) }, // tabs: [{ text, query, attrs, listeners }]
    showPagination: { type: Boolean, default: false },
    perPage: { type: Number, default: 10 },
    autoNextTab: { type: Boolean, default: false },
  },
  data() {
    return {
      items: [this.value].flat(),

      filterTab: 0,
    };
  },
  computed: {
    searchComponent() {
      const { mini } = this.searchProps || {};
      if (mini) return DSearchFieldsMini;
      return DSearchFields;
    },
    hasSearch() {
      const { attrs } = this.searchProps || {};
      return !!Object.keys(attrs || {}).length;
    },
    filterTabs() {
      const { tabs } = this.filterProps || {};
      return (tabs || []).map(({ text, query, attrs, listeners }) => ({
        text,
        query: query || {},
        attrs: attrs || {},
        listeners: listeners || {},
      }));
    },
    hasFilter() {
      return !!this.filterTabs.length;
    },
    serverDataAttrs() {
      return {
        'start-loading-value': true,
        method: this.currentMethod,
        serializeData: (response) => response.items,
        debounceDelay: 0,
        ...this.$attrs,
      };
    },
  },
  methods: {
    currentMethod({ params }) {
      const currentTab = this.filterTabs?.[this.filterTab] || {};
      return this.method({
        params: {
          'per-page': this.perPage,
          sort: 'id',
          ...params,
          ...currentTab?.query,
        },
      });
    },
    dataInit(data) {
      if (!(data && data.length) && (this.filterTabs?.length > 1) && !this.filterTab && this.autoNextTab) {
        this.filterTab += 1;
        this.$nextTick(() => {
          this.refresh();
        });
      }
      this.$emit('data:init', data);
    },
    refresh() {
      const { init, loading } = this.$refs?.serverData || {};
      if (init && !loading) init?.();
    },
  },
};
</script>
